<template>
  <t-layout>
    <div class="page">
      <iframe class="iframe" :src="url"> </iframe>
    </div>
  </t-layout>
</template>

<script>
export default {
  name: 'webview',
  components: {},
  data() {
    return {
      url: ''
    }
  },
  created() {
    const options = this.$route.query
    this.url = decodeURIComponent(options.url)
    console.log('url', this.url)
  }
}
</script>

<style lang="less" scoped>
.page {
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

.iframe {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
